import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import * as Connection from "./../libs/connections";

import Preloader from "./../components/global/Preloader";
import HeroBannerSmall from "../components/HeroBannerSmall";
import SectionFAQ from "../components/SectionFAQ";
import ShowroomFullScreen from "../components/ShowroomFullScreen";

import heroBackground from "../assets/header/header-faq.svg";

export default class FaqPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      headertext: "",
      elements: []
    };
  }

  async componentDidMount() {
    try {
      const response = await Connection.getPageBySlug("faq");
      this.setState({
        loading: false,
        headertext: response.acf.headertext,
        elements: response.acf.elements,
        bannerShowRoom: response.acf.showroom
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    if (!this.state.error) {
      return (
        <div className="page-faq">
          <Preloader global loading={this.state.loading} />
          {this.state.headertext && (
            <HeroBannerSmall
              backgroundImage={heroBackground}
              changeOpacity={true}
              fontSize={120}
              headerText={this.state.headertext}
            />
          )}
          {this.state.elements.length > 0 && (
            <SectionFAQ elements={this.state.elements} />
          )}
          {this.state.bannerShowRoom && (
            <ShowroomFullScreen
              backgroundImage={this.state.bannerShowRoom.photoUrl}
              text={
                <div className="showroom-text">
                  <div className="container container-small">
                    <div className="row">
                      <div className="col-12">
                        <h5>
                          <span>V1RAGE.</span>
                          Kontakt
                        </h5>
                        <p style={{ marginBottom: "60px" }}>
                          Chcesz coś jeszcze omówić?
                        </p>
                        <Link
                          className="btn-general btn-general--primary"
                          to="/kontakt"
                        >
                          Kontakt
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          )}
        </div>
      );
    } else {
      return <Redirect to="/error" />;
    }
  }
}
